import { render, staticRenderFns } from "./ImportText.vue?vue&type=template&id=38b11396"
import script from "./ImportText.vue?vue&type=script&lang=js"
export * from "./ImportText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports